export default {
	"de": {
		"Add text..."                                                : "Text hinzufügen...",
		"Open Editor"                                                : "Editor öffnen",
		"Image Editor"                                               : "Bildbearbeiter",
		"Image is not editable"                                      : "Bild kann nicht bearbeitet werden",
		"Exit draw mode"                                             : "Zeichnungsmodus beenden",
		"Save"                                                       : "Speichern",
		"Delete Element"                                             : "Element löschen",
		"Add Text"                                                   : "Text hinzufügen",
		"Add Image"                                                  : "Bild hinzufügen",
		"Draw Line"                                                  : "Linie zeichnen",
		"Draw Arrow"                                                 : "Pfeil zeichnen",
		"Draw Rectangle"                                             : "Rechteck zeichnen",
		"Draw Circle"                                                : "Kreis zeichen",
		"Clear"                                                      : "Zurücksetzen",
		"Loading PDF File"                                           : 'PDF Datei wird geladen',
		'Error occurred during loading PDF file. Please reload page.': 'Fehler beim Laden der PDF Datei aufgetreten. Bitte aktualisieren Sie die Seite.',
		"Add GF-AP"                                                  : "GF-AP hinzufügen",
		"Add KVB"                                                    : "KVB hinzufügen"
	}
}
